import { useQuery } from "hooks/useQuery";
import { getSimilarStrategies } from "../service";

export const useSimilarStrategies = (strategyId) => {
  const queryKey = ["similar-strategies", strategyId];

  const queryFn = () => getSimilarStrategies(strategyId);

  const { data, isLoading, isError, error, isSuccess, refetch } = useQuery({
    queryKey,
    queryFn,
    enabled: !!strategyId,
  });

  return {
    data: data?.data || [],
    isLoading,
    isError,
    error,
    isSuccess,
    refetch,
  };
};
